export function isUnauthorizedApiError(error) {
  return error === "Unauthorized" || error === "Unauthorized!";
}

/**
 * Returns true when a post-login bootstrap API has failed with a
 * non-authorization error (rep info or speech config).
 */
export function hasFirstLayerApiFailure(state) {
  const { repEmails, speechConfig } = state;

  const repEmailsSettled = repEmails.success || repEmails.isError;
  const speechConfigSettled = speechConfig.success || speechConfig.isError;

  if (!repEmailsSettled || !speechConfigSettled) {
    return false;
  }

  const failures = [
    repEmails.isError && repEmails.error,
    speechConfig.isError && speechConfig.error,
  ].filter(Boolean);

  return failures.some((error) => !isUnauthorizedApiError(error));
}
